import { useEffect, useMemo, useState } from 'react'

/* ===========================================================================
 *  Klaar: alles wat op jou wachtte is gedaan
 *
 *  Overgenomen uit TW10 Online (b10/Klaar.tsx, 22 okt 2026). Casper: "Als je
 *  klaar met je facturen bent, moet er een leuke animatie in beeld komen om
 *  iemand te motiveren dat degene klaar is met het vervelende stuk." En op
 *  23 okt 2026 voor de telefoon: "echt hetgene wat desktop ook heeft, moet
 *  je ook doen".
 *
 *  Een vinkje dat zich tekent, zeepbellen die omhoog gaan (we zijn een
 *  wasstraat) en een regel tekst. Alleen als je net je LAATSTE factuur
 *  afhandelde -- niet bij het openen van een lege lijst. Vijf seconden, of
 *  weg met een tik. Wie minder beweging wil (prefers-reduced-motion) krijgt
 *  alleen het vinkje.
 *
 *  Factuur.tsx roept afgehandeld() bij elke factuur en vier() als er niets
 *  meer op je wacht (volgendeVoorMij in lib/bakken.ts).
 * =========================================================================== */

let teller = 0
let kijker: ((n: number) => void) | null = null

/** Eén factuur afgehandeld (getekend, gevalideerd, afgekeurd of teruggezet). */
export function afgehandeld() {
  teller++
}

/** Niets meer op jouw naam: laat het zien. */
export function vier() {
  kijker?.(teller)
  teller = 0
}

const ZINNEN = [
  'Het vervelende stuk is gedaan.',
  'Schoon de weg op.',
  'Je stapel is leeg. Lekker gewerkt.',
]

export default function Klaar() {
  const [aantal, setAantal] = useState<number | null>(null)

  useEffect(() => {
    kijker = (n) => setAantal(n)
    return () => { kijker = null }
  }, [])

  useEffect(() => {
    if (aantal === null) return
    const t = window.setTimeout(() => setAantal(null), 5000)
    return () => window.clearTimeout(t)
  }, [aantal])

  /* De bellen: elk zijn eigen plek, maat en tempo; nieuw bij elke keer. */
  const bellen = useMemo(() => Array.from({ length: 18 }, () => ({
    links: Math.random() * 100,
    maat: 14 + Math.random() * 40,
    duur: 2.6 + Math.random() * 2.2,
    wacht: Math.random() * 1.2,
    zwaai: (Math.random() - 0.5) * 60,
  })), [aantal])

  if (aantal === null) return null
  const zin = ZINNEN[aantal % ZINNEN.length]

  return (
    <div className="klaar" role="status" aria-live="polite" onClick={() => setAantal(null)}>
      <div className="klaar-bellen" aria-hidden="true">
        {bellen.map((b, i) => (
          <span key={i} style={{
            left: `${b.links}%`, width: b.maat, height: b.maat,
            animationDuration: `${b.duur}s`, animationDelay: `${b.wacht}s`,
            ['--zwaai' as string]: `${b.zwaai}px`,
          }} />
        ))}
      </div>
      <div className="klaar-kaart">
        <svg className="klaar-vink" viewBox="0 0 80 80" aria-hidden="true">
          <circle cx="40" cy="40" r="36" />
          <path d="M24 41 L35 52 L57 29" />
        </svg>
        <h2>Klaar!</h2>
        <p>Er wacht niets meer op jou. {zin}</p>
        {aantal > 0 && <p className="zacht">{aantal === 1 ? 'Eén factuur' : `${aantal} facturen`} afgehandeld in deze ronde.</p>}
      </div>
    </div>
  )
}
